import { ApiError } from '@/apis'

/**
 * 카드 등록 API 에러 코드 → 사용자 메시지 매핑.
 *
 * apidog 명세 기준(POST /payments/methods 응답 422·409·503).
 * 코드별로 안내 톤은 해요체 통일. 일반 에러는 fallback.
 */

const FALLBACK_MESSAGE = '카드 등록에 실패했어요. 잠시 후 다시 시도해주세요'

const ERROR_MESSAGE_MAP: Record<string, string> = {
  E409300: '이미 등록된 카드예요',
  E422301: '생년월일 또는 사업자등록번호가 잘못됐어요',
  E422302: '카드 유효기간이 잘못됐어요',
  E422303: '카드 비밀번호가 잘못됐어요',
  E422304: '카드 비밀번호를 3회 이상 틀렸어요. 고객센터로 문의해주세요',
  E422314: '결제수단은 최대 10개까지 등록할 수 있어요',
  E503301: FALLBACK_MESSAGE,
}

export function getCardRegisterErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const mapped = ERROR_MESSAGE_MAP[error.code]
    if (mapped) return mapped
    // 매핑 안 된 코드 — 백엔드가 내려준 사유를 최대한 노출한다 (message + description 둘 다).
    // backend 가 message 를 안 주면 ApiError.message 는 code 로 채워지므로 (super(message ?? code)),
    // code 와 같으면 사용자에게 코드가 노출되지 않도록 제외.
    const lines: string[] = []
    const backendMessage = error.message?.trim()
    if (backendMessage && backendMessage !== error.code) lines.push(backendMessage)
    const description = error.description?.trim()
    if (description && description !== backendMessage) lines.push(description)
    return lines.length > 0 ? lines.join('\n') : FALLBACK_MESSAGE
  }
  return FALLBACK_MESSAGE
}
